export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8139.88f301f8.jpg";